(() => {
  const CART_ENABLED = true;
  const PRICE_TIERS = Object.freeze([4990, 5490, 5990, 6490, 6990, 7490, 7990, 8190]);
  const PRICE_ANCHORS = Object.freeze([3500, 4200, 5250, 6084, 6375]);
  const PRICE_BASES = Object.freeze([4490, 4490, 4490, 5190, 5390]);
  const PRICE_VARIANTS = window.KK_WAF_PRICE_VARIANTS || Object.freeze({});
  const ARROW_KEYS = Object.freeze(['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp']);
  const roundHalfUp = (value, divisor) => Math.floor((value + divisor / 2) / divisor);
  const exactPriceCents = (width, depth) => {
    const area = Math.round(Number(width) * Number(depth));
    if (area <= PRICE_ANCHORS[0]) return PRICE_BASES[0] + 500;
    const last = PRICE_ANCHORS.length - 1;
    if (area >= PRICE_ANCHORS[last]) return roundHalfUp(area * PRICE_BASES[last], PRICE_ANCHORS[last]) + 500;
    const index = PRICE_ANCHORS.findIndex((anchor, i) => area >= anchor && area <= PRICE_ANCHORS[i + 1]);
    const span = PRICE_ANCHORS[index + 1] - PRICE_ANCHORS[index];
    return PRICE_BASES[index] + roundHalfUp((area - PRICE_ANCHORS[index]) * (PRICE_BASES[index + 1] - PRICE_BASES[index]), span) + 500;
  };
  const getTier = (exactCents) => {
    const index = PRICE_TIERS.findIndex((tier) => tier >= exactCents);
    const tierIndex = index < 0 ? PRICE_TIERS.length - 1 : index;
    return { id: `P${String(tierIndex + 1).padStart(2, '0')}`, priceCents: PRICE_TIERS[tierIndex] };
  };
  const money = (cents, locale = 'en') => new Intl.NumberFormat(locale || 'en', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const getVariant = (design, tier) => {
    if (!design?.stoffcode || !tier?.id) return null;
    const targetSku = `${design.stoffcode}112-SM-${tier.id}`;
    const mapped = PRICE_VARIANTS[targetSku];
    if (!mapped || mapped.priceCents !== tier.priceCents || !/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(mapped.variantId)) return null;
    return { targetSku, variantId: mapped.variantId, priceCents: mapped.priceCents };
  };
  const numericVariantId = (variantId) => {
    const numericId = String(variantId || '').split('/').pop();
    return /^\d+$/.test(numericId) ? numericId : null;
  };
  const STANDARD_SIZES = Object.freeze({ '50x70': '50', '60x70': '60', '75x70': '75', '78x78': '78', '85x75': '85' });
  const validDimensions = (w, d, width, depth) => Number.isInteger(w) && Number.isInteger(d) && w >= Number(width.min) && w <= Number(width.max) && d >= Number(depth.min) && d <= Number(depth.max);

  document.querySelectorAll('[data-kk-waf-root]').forEach((root) => {
    const text = (key) => root.dataset[key] || '';
    const moneyLocale = root.dataset.moneyLocale || document.documentElement.lang || 'en';
    const cards = [...root.querySelectorAll('[data-kk-waf-card]')];
    const fabricTypes = [...root.querySelectorAll('[data-kk-waf-fabric-type]')];
    const fabricGroups = [...root.querySelectorAll('[data-kk-waf-fabric-group]')];
    const swatches = [...root.querySelectorAll('[data-kk-waf-swatch]')];
    const width = root.querySelector('[data-kk-waf-width]');
    const depth = root.querySelector('[data-kk-waf-depth]');
    if (!width || !depth) return;
    const widthOutput = root.querySelector('[data-kk-waf-width-output]');
    const depthOutput = root.querySelector('[data-kk-waf-depth-output]');
    const price = root.querySelector('[data-kk-waf-price]');
    const selectedDesign = root.querySelector('[data-kk-waf-selected-design-label], .kk-waf__selected-design-label');
    const propertiesOutput = root.querySelector('[data-kk-waf-properties]');
    const customApply = root.querySelector('[data-kk-waf-custom-apply]');
    const addToCart = root.querySelector('[data-kk-waf-add-to-cart]');
    const status = root.querySelector('[data-kk-waf-status]');
    const customCard = root.querySelector('[data-kk-waf-custom-card]');
    const outerPath = root.querySelector('[data-kk-waf-svg-outer]');
    const innerPath = root.querySelector('[data-kk-waf-svg-inner]');
    const widthLine = root.querySelector('[data-kk-waf-svg-width-line]');
    const depthLine = root.querySelector('[data-kk-waf-svg-depth-line]');
    const widthLabel = root.querySelector('[data-kk-waf-svg-width-label]');
    const depthLabel = root.querySelector('[data-kk-waf-svg-depth-label]');
    const summaryImage = root.querySelector('[data-kk-waf-summary-image]');
    const summaryPlaceholder = root.querySelector('[data-kk-waf-summary-placeholder]');
    const summaryDimensions = root.querySelector('[data-kk-waf-summary-dimensions]');
    const summaryFabric = root.querySelector('[data-kk-waf-summary-fabric]');
    const summaryDesign = root.querySelector('[data-kk-waf-summary-design]');
    const panels = [...root.querySelectorAll('[data-kk-waf-step-panel]')];
    const toggles = [...root.querySelectorAll('[data-kk-waf-step-toggle]')];
    const steps = [...root.querySelectorAll('[data-kk-waf-step]')];
    const modeButtons = [...root.querySelectorAll('[data-kk-waf-mode]')];
    const modePanels = [...root.querySelectorAll('[data-kk-waf-mode-panel]')];
    const collectionLink = root.querySelector('[data-kk-waf-collection-link]');
    const collectionNote = root.querySelector('[data-kk-waf-collection-note]');
    const nativeSizeValues = [...root.querySelectorAll('[data-kk-waf-native-size]')].map((item) => item.dataset.kkWafNativeSize || '').filter(Boolean);
    const skuPattern = root.dataset.kkWafSkuPattern || '{STOFFCODE}112-SM';
    const customLabel = () => `${width.value} × ${depth.value} cm`;
    const parseDimensions = (value) => { const m = String(value || '').match(/(\d+)\s*[x×*]\s*(\d+)/i); return m ? { width: Number(m[1]), depth: Number(m[2]), key: `${Number(m[1])}x${Number(m[2])}` } : null; };
    const cardDimensions = (card) => parseDimensions(card?.dataset.sizeLabel);
    let activeFabricKey = '';
    let design = null;
    let cartBusy = false;
    let lastVariant = null;
    let selection = null;
    let openStep = 'size';
    let sizeMode = 'custom';
    const setStatus = (message) => { if (status) status.textContent = message; };
    const dimsText = (dims) => `${dims.width} × ${dims.depth} cm`;
    const selectedDimensions = () => selection ? (selection.type === 'standard' ? cardDimensions(cards.find((c) => c.dataset.cardId === selection.id)) : { width: selection.width, depth: selection.depth }) : null;
    const stepName = (step) => root.querySelector(`[data-kk-waf-step-summary="${step}"]`);
    const setOpenStep = (step, { focus = false, scroll = false } = {}) => {
      const order = ['size', 'fabric', 'design', 'summary'];
      const currentIndex = order.indexOf(step);
      const allowed = step === 'size' || (selection && currentIndex <= (design ? 3 : (activeFabricKey ? 2 : 1)));
      if (!allowed) return;
      openStep = step;
      steps.forEach((node) => {
        const name = node.dataset.kkWafStep;
        const toggle = node.querySelector('[data-kk-waf-step-toggle]');
        const panel = node.querySelector('[data-kk-waf-step-panel]');
        const canOpen = name === 'size' || Boolean(selection && (name === 'fabric' || activeFabricKey) && (name !== 'design' || activeFabricKey) && (name !== 'summary' || design));
        if (toggle) { toggle.disabled = !canOpen; toggle.setAttribute('aria-expanded', String(name === openStep)); }
        if (panel) panel.hidden = name !== openStep;
        node.classList.toggle('is-open', name === openStep);
        node.classList.toggle('is-complete', name !== openStep && (name === 'size' ? Boolean(selection) : name === 'fabric' ? Boolean(activeFabricKey) : name === 'design' ? Boolean(design) : false));
        const change = node.querySelector('[data-kk-waf-step-change]');
        if (change) change.hidden = name === openStep || !canOpen;
      });
      if (focus) root.querySelector(`[data-kk-waf-step-toggle="${step}"]`)?.focus();
      updateCartButton(lastVariant);
      if (scroll && window.matchMedia('(max-width: 749px)').matches) {
        root.querySelector(`[data-kk-waf-step="${step}"]`)?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    };
    const setMode = (mode) => {
      sizeMode = mode;
      modeButtons.forEach((button) => { const active = button.dataset.kkWafMode === mode; button.classList.toggle('is-selected', active); button.setAttribute('aria-pressed', String(active)); });
      modePanels.forEach((panel) => { panel.hidden = panel.dataset.kkWafModePanel !== mode; });
    };
    const resetDesignDisplay = () => {
      if (selectedDesign) selectedDesign.textContent = text('textSelectBoth');
      if (propertiesOutput) propertiesOutput.textContent = text('textPropertiesAfterSelection');
      if (summaryDesign) summaryDesign.textContent = '';
      if (summaryImage) { summaryImage.hidden = true; summaryImage.removeAttribute('src'); }
      if (summaryPlaceholder) summaryPlaceholder.hidden = false;
    };
    const summaryLine = (step, value) => { const node = stepName(step); if (node) node.textContent = value || ''; };
    const syncCollectionLink = () => {
      if (!collectionLink || !root.dataset.kkWafCollectionUrl || !collectionNote) return;
      const target = new URL(root.dataset.kkWafCollectionUrl, window.location.origin);
      const dimensions = selectedDimensions();
      let sizeApplied = false;
      if (selection?.type === 'standard' && dimensions) {
        const matchingNativeValues = [...new Set(nativeSizeValues.filter((value) => parseDimensions(value)?.key === dimensions.key))];
        matchingNativeValues.forEach((value) => target.searchParams.append('filter.v.option.größe', value));
        sizeApplied = matchingNativeValues.length > 0;
      } else if (selection?.type === 'custom' && dimensions) {
        target.searchParams.set('kk_mini_width', String(dimensions.width));
        target.searchParams.set('kk_mini_depth', String(dimensions.depth));
      }
      const activeGroup = fabricGroups.find((group) => group.dataset.fabricKey === activeFabricKey);
      const activeDesigns = activeGroup ? [...activeGroup.querySelectorAll('[data-kk-waf-swatch]')].filter((item) => !item.hidden) : [];
      const toFabricGid = (value) => {
        const raw = String(value || '');
        if (/^gid:\/\/shopify\/Metaobject\/\d+$/.test(raw)) return raw;
        return /^\d+$/.test(raw) ? 'gid://shopify/Metaobject/' + raw : '';
      };
      const fabricGids = [...new Set(activeDesigns.map((item) => toFabricGid(item.dataset.designGid)).filter(Boolean))];
      fabricGids.forEach((gid) => target.searchParams.append('filter.p.m.custom.used_fabrics_filter', gid));
      const selectedDesignGid = toFabricGid(design?.designGid);
      if (selectedDesignGid && fabricGids.includes(selectedDesignGid)) target.searchParams.set('kk_return_design', selectedDesignGid);
      if (new URLSearchParams(window.location.search).get('preview_theme_id') === '210188665100') target.searchParams.set('preview_theme_id', '210188665100');
      collectionLink.href = target.pathname + target.search;
      if (!selection) collectionNote.textContent = text('textCollectionNoteUnfiltered');
      else if (selection.type === 'custom') collectionNote.textContent = text('textCollectionNoteCustom');
      else if (sizeApplied && fabricGids.length) collectionNote.textContent = text('textCollectionNoteFamily');
      else if (sizeApplied) collectionNote.textContent = text('textCollectionNoteSize');
      else if (fabricGids.length) collectionNote.textContent = text('textCollectionNoteFamilySizeUnavailable');
      else collectionNote.textContent = text('textCollectionNoteSizeUnavailable');
      collectionNote.hidden = false;
    };
    const syncState = (tier = null, variant = null) => {
      const dims = selectedDimensions();
      root.dataset.kkWafSelectionType = selection?.type || 'draft';
      root.dataset.kkWafSelectionLabel = selection?.label || '';
      root.dataset.kkWafSelectionDesign = design?.label || '';
      root.dataset.kkWafSelectionStoffcode = design?.stoffcode || '';
      root.dataset.kkWafSelectionPriceTier = tier?.id || '';
      root.dataset.kkWafSelectionTierPriceCents = variant?.priceCents ? String(variant.priceCents) : '';
      root.dataset.kkWafSelectionTargetSku = variant?.targetSku || '';
      root.dataset.priceTier = tier?.id || '';
      root.dataset.tierPriceCents = variant?.priceCents ? String(variant.priceCents) : '';
      root.dataset.design = design?.label || '';
      root.dataset.stoffcode = design?.stoffcode || '';
      root.dataset.targetSku = variant?.targetSku || '';
      root.dataset.kkWafSelectionSkuReference = selection?.type === 'standard' ? (design?.sourceVariantSku || '') : (design?.skuReference || skuPattern.replace('{STOFFCODE}', design?.stoffcode || ''));
      root.dataset.kkWafSelectionProductId = design?.productId || '';
      root.dataset.kkWafSelectionProductHandle = design?.productHandle || '';
      root.dataset.kkWafSelectionSourceVariantId = design?.sourceVariantId || '';
      root.dataset.kkWafSelectionSourceVariantSku = design?.sourceVariantSku || '';
      root.dataset.kkWafSelectionTargetVariantId = variant?.variantId || '';
      if (selectedDesign) selectedDesign.textContent = design?.label || text('textSelectBoth');
      if (propertiesOutput) propertiesOutput.textContent = design?.facts || text('textPropertiesAfterSelection');
      if (summaryDimensions) summaryDimensions.textContent = dims ? dimsText(dims) : '';
      if (summaryFabric) summaryFabric.textContent = fabricTypes.find((item) => item.dataset.fabricKey === activeFabricKey)?.textContent?.trim() || '';
      if (summaryDesign) summaryDesign.textContent = design?.label || '';
      syncCollectionLink();
    };
    const updateCartButton = (variant) => {
      if (!addToCart) return;
      addToCart.disabled = cartBusy || !CART_ENABLED || !selection || !design || openStep !== 'summary' || !variant;
      lastVariant = variant || null;
      addToCart.setAttribute('aria-disabled', String(addToCart.disabled));
      addToCart.setAttribute('aria-busy', String(cartBusy));
    };
    const updatePrice = () => {
      const confirmedDimensions = selectedDimensions();
      const tier = selection?.type === 'custom' && confirmedDimensions ? getTier(exactPriceCents(confirmedDimensions.width, confirmedDimensions.depth)) : null;
      const standardVariant = selection?.type === 'standard' && design && design.availableSize === selection.sizeKey && design.sourceVariantId ? { targetSku: design.sourceVariantSku, variantId: design.sourceVariantId, priceCents: Number(design.variantPriceCents) } : null;
      const customVariant = selection?.type === 'custom' && design ? getVariant(design, tier) : null;
      const variant = selection?.type === 'custom' ? customVariant : standardVariant;
      if (price) price.textContent = variant ? `${text('textTotalPrice')} ${money(variant.priceCents, moneyLocale)}` : text('textSelectDesign');
      updateCartButton(variant);
      syncState(tier, variant);
      return { tier, variant };
    };
    const updateGraphic = () => {
      const w = Number(width.value), d = Number(depth.value);
      const scale = Math.min(126 / w, 96 / d);
      const shapeWidth = w * scale, shapeHeight = d * scale;
      const left = 100 - shapeWidth / 2, right = 100 + shapeWidth / 2;
      const top = 71 - shapeHeight / 2, bottom = 71 + shapeHeight / 2;
      const radius = Math.min(5, shapeWidth * .12, shapeHeight * .08);
      const inset = Math.min(18, shapeWidth * .22, shapeHeight * .24);
      const innerLeft = left + inset, innerRight = right - inset, innerTop = top + inset;
      outerPath?.setAttribute('d', `M ${left + radius} ${top} L ${right - radius} ${top} Q ${right} ${top} ${right} ${top + radius} L ${right} ${bottom - radius} Q ${right} ${bottom} ${right - radius} ${bottom} L ${left + radius} ${bottom} Q ${left} ${bottom} ${left} ${bottom - radius} L ${left} ${top + radius} Q ${left} ${top} ${left + radius} ${top} Z`);
      innerPath?.setAttribute('d', `M ${innerLeft} ${innerTop} L ${innerLeft} ${bottom - inset / 2} M ${innerLeft} ${innerTop} L ${innerRight} ${innerTop} L ${innerRight} ${bottom - inset / 2}`);
      widthLine?.setAttribute('d', `M ${left} ${bottom + 8} L ${right} ${bottom + 8}`);
      depthLine?.setAttribute('d', `M ${left - 10} ${top} L ${left - 10} ${bottom}`);
      if (widthLabel) { widthLabel.textContent = `${w} cm`; widthLabel.setAttribute('x', '100'); widthLabel.setAttribute('y', `${bottom + 17}`); }
      if (depthLabel) { depthLabel.textContent = `${d} cm`; depthLabel.setAttribute('x', `${left - 15}`); depthLabel.setAttribute('y', `${(top + bottom) / 2}`); depthLabel.setAttribute('transform', `rotate(-90 ${left - 15} ${(top + bottom) / 2})`); }
      if (widthOutput) widthOutput.textContent = `${w} cm`;
      if (depthOutput) depthOutput.textContent = `${d} cm`;
      [width, depth].forEach((input) => { const min = Number(input.min), max = Number(input.max), value = Number(input.value); input.style.setProperty('--kk-waf-range-progress', `${((value - min) / (max - min)) * 100}%`); });
    };
    const clearDesign = (message = '') => {
      design = null;
      swatches.forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-checked', 'false'); item.tabIndex = item.closest('[data-kk-waf-fabric-group]')?.hidden === false && !item.hidden ? 0 : -1; const label = item.querySelector('[data-kk-waf-design-label]'); if (label) label.textContent = label.dataset.labelSelect || ''; });
      resetDesignDisplay(); summaryLine('design', ''); setStatus(message); updatePrice();
    };
    const candidateDesign = (item) => ({ label: item.dataset.designLabel || '', stoffcode: item.dataset.stoffcode || '', productId: item.dataset.productId || '', productHandle: item.dataset.productHandle || '', sourceVariantId: item.dataset.sourceVariantId || '', sourceVariantSku: item.dataset.sourceVariantSku || '', sourceVariantImage: item.dataset.sourceVariantImage || '', skuReference: item.dataset.skuReference || '', facts: item.dataset.stoffeigenschaften || '', availableSize: item.dataset.availableSize || '', variantPriceCents: item.dataset.variantPriceCents || '', designGid: item.dataset.designGid || '' });
    const updateVisibleDesignCards = ({ rebind = true } = {}) => {
      const selectedGid = design?.designGid || '';
      fabricGroups.forEach((group) => {
        const seen = new Set();
        group.querySelectorAll('[data-kk-waf-swatch]').forEach((item) => {
          const size = item.dataset.availableSize || '';
          const candidate = candidateDesign(item);
          const identity = candidate.designGid || `${candidate.stoffcode}:${candidate.sourceVariantSku}`;
          const confirmed = selectedDimensions();
          const tier = confirmed ? getTier(exactPriceCents(confirmed.width, confirmed.depth)) : null;
          const matchesSize = !selection ? false : selection.type === 'custom' ? Boolean(getVariant(candidate, tier)) : size === selection.sizeKey;
          const duplicate = selection?.type === 'custom' && seen.has(identity);
          item.hidden = !matchesSize || duplicate;
          if (matchesSize && !duplicate) seen.add(identity);
          const meta = item.querySelector('.kk-waf__design-meta');
          if (meta && selection?.type === 'custom' && confirmed && tier) meta.textContent = `${dimsText(confirmed)} · ${money(tier.priceCents, moneyLocale)}`;
          else if (meta && size) meta.textContent = `${size.replace('x', ' × ')} cm · ${money(Number(item.dataset.variantPriceCents), moneyLocale)}`;
        });
        const visible = [...group.querySelectorAll('[data-kk-waf-swatch]')].filter((item) => !item.hidden);
        group.dataset.empty = String(!visible.length);
        const emptyMessage = group.querySelector('[data-kk-waf-empty]'); if (emptyMessage) emptyMessage.hidden = Boolean(visible.length);
      });
      swatches.forEach((item) => { item.tabIndex = item.closest('[data-kk-waf-fabric-group]')?.hidden === false && !item.hidden ? -1 : -1; });
      const activeGroup = fabricGroups.find((group) => group.dataset.fabricKey === activeFabricKey);
      const visible = activeGroup ? [...activeGroup.querySelectorAll('[data-kk-waf-swatch]')].filter((item) => !item.hidden) : [];
      if (design && rebind) {
        const target = visible.find((item) => item.dataset.designGid === selectedGid);
        if (target) { applyDesign(target, { advance: false }); }
        else { clearDesign(text('textDesignUnavailable')); if (openStep === 'summary') setOpenStep('design'); }
      }
      const checked = visible.find((item) => item.classList.contains('is-selected'));
      (checked || visible[0])?.setAttribute('tabindex', '0');
      swatches.forEach((item) => { const base = item.dataset.ariaLabelBase || item.dataset.designLabel || ''; const confirmed = selectedDimensions(); item.setAttribute('aria-label', `${base}${selection?.type === 'custom' && confirmed ? ` · ${dimsText(confirmed)}` : (item.dataset.availableSize ? ` · ${item.dataset.availableSize.replace('x', ' × ')} cm` : '')}`); });
    };
    const applyDesign = (swatch, { advance = true } = {}) => {
      if (!swatch || swatch.hidden || !selection) return;
      design = candidateDesign(swatch);
      setStatus('');
      swatches.forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected); item.setAttribute('aria-checked', String(selected)); item.tabIndex = selected ? 0 : -1;
        const label = item.querySelector('[data-kk-waf-design-label]'); if (label) label.textContent = selected ? (label.dataset.labelSelected || '') : (label.dataset.labelSelect || '');
      });
      if (selectedDesign) selectedDesign.textContent = design.label;
      if (propertiesOutput) propertiesOutput.textContent = design.facts || text('textNoProperties');
      if (summaryImage) {
        if (design.sourceVariantImage) { summaryImage.src = design.sourceVariantImage; summaryImage.hidden = false; if (summaryPlaceholder) summaryPlaceholder.hidden = true; }
        else { summaryImage.hidden = true; if (summaryPlaceholder) summaryPlaceholder.hidden = false; }
      }
      if (selection.type === 'custom') selection.label = `${dimsText(selectedDimensions())} · ${design.label}`;
      else selection.label = `${cards.find((c) => c.dataset.cardId === selection.id)?.dataset.sizeLabel || selection.label.split(' · ')[0]} · ${design.label}`;
      if (advance) setOpenStep('summary', { scroll: true, focus: true });
      updatePrice();
      summaryLine('fabric', fabricTypes.find((item) => item.dataset.fabricKey === activeFabricKey)?.textContent?.trim());
      summaryLine('design', design.label);
      syncCollectionLink();
    };
    const commitSize = (next, { mode = null, incoming = false } = {}) => {
      const exactCard = cards.find((card) => cardDimensions(card)?.key === `${next.width}x${next.depth}`);
      width.value = String(next.width); depth.value = String(next.depth); updateGraphic();
      const priorDesignGid = design?.designGid;
      if (exactCard) {
        selection = { type: 'standard', id: exactCard.dataset.cardId, label: exactCard.dataset.sizeLabel, sizeKey: `${next.width}x${next.depth}`, url: exactCard.dataset.resultUrl || '' };
        setMode('standard');
      } else {
        selection = { type: 'custom', width: next.width, depth: next.depth, label: dimsText(next), sizeKey: '', url: '' };
        setMode(mode || 'custom');
      }
      cards.forEach((card) => { const selected = selection.type === 'standard' && card.dataset.cardId === selection.id; card.classList.toggle('is-selected', selected); card.setAttribute('aria-pressed', String(selected)); });
      if (customCard) customCard.dataset.selected = String(selection.type === 'custom');
      if (customApply) customApply.setAttribute('aria-pressed', String(selection.type === 'custom'));
      summaryLine('size', selection.label);
      updateVisibleDesignCards({ rebind: Boolean(priorDesignGid) });
      if (priorDesignGid && !design) setStatus(text('textDesignUnavailable'));
      updatePrice();
      setOpenStep('fabric', { scroll: !incoming, focus: !incoming });
      syncCollectionLink();
      return selection;
    };
    const setFabricType = (button, advance = true) => {
      const nextKey = button?.dataset.fabricKey || '';
      if (nextKey && nextKey === activeFabricKey) { if (advance) setOpenStep('design', { scroll: true, focus: true }); return; }
      activeFabricKey = nextKey;
      fabricTypes.forEach((item) => { const selected = item === button; item.classList.toggle('is-selected', selected); item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
      fabricGroups.forEach((group) => { group.hidden = group.dataset.fabricKey !== activeFabricKey; });
      clearDesign('');
      updateVisibleDesignCards({ rebind: false });
      const group = fabricGroups.find((item) => item.dataset.fabricKey === activeFabricKey);
      const visible = group ? [...group.querySelectorAll('[data-kk-waf-swatch]')].filter((item) => !item.hidden) : [];
      if (visible[0]) visible[0].tabIndex = 0;
      if (!visible.length) setStatus(text('textDesignUnavailable')); 
      summaryLine('fabric', button?.textContent?.trim() || ''); summaryLine('design', '');
      syncCollectionLink();
      if (advance) setOpenStep('design', { scroll: true, focus: true });
    };
    const refreshConfiguredCart = async () => {
      if (typeof window.refreshCart === 'function') {
        const result = window.refreshCart(true);
        if (result && typeof result.then === 'function') await result; else await new Promise((resolve) => window.setTimeout(resolve, 250));
        return;
      }
      const response = await fetch('?section_id=helper-cart', { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Cart refresh failed');
      const html = await response.text();
      if (typeof window.renderHelperCart !== 'function') throw new Error('Cart renderer unavailable');
      window.renderHelperCart(html);
      const drawer = document.querySelector('[data-js-site-cart-sidebar]'); if (drawer && typeof drawer.show === 'function') drawer.show();
    };
    const addConfiguredItem = async () => {
      if (cartBusy || !CART_ENABLED || !selection || !design || openStep !== 'summary') return;
      const { tier, variant } = updatePrice();
      const variantId = numericVariantId(variant?.variantId);
      if (!variant || !variantId || (selection.type === 'standard' && design.availableSize !== selection.sizeKey) || (selection.type === 'custom' && !tier)) { setStatus(text('textInvalidSelection')); return; }
      cartBusy = true; updateCartButton(variant); root.setAttribute('aria-busy', 'true'); setStatus(text('textAddingCart'));
      const dimensions = selectedDimensions();
      const properties = {
        [text('textWidthProperty')]: `${dimensions.width} cm`,
        [text('textDepthProperty')]: `${dimensions.depth} cm`,
        [text('textMeasureProperty')]: selection.type === 'custom' ? dimsText(dimensions) : selection.label.split(' · ')[0],
        [text('textFabricDesignProperty')]: design.label,
        _kk_stoffbild: design.sourceVariantImage
      };
      if (selection.type === 'custom') Object.assign(properties, { _kk_schema: root.dataset.kkWafSchema || 'wickelauflage-sondermass-v1', _kk_stoffcode: design.stoffcode, _kk_preisstufe: tier.id, _kk_sku_referenz: design.skuReference || `${design.stoffcode}112-SM`, _kk_source_product: design.productId || design.productHandle || '' });
      else Object.assign(properties, { _kk_stoffcode: design.stoffcode, _kk_sku_referenz: design.sourceVariantSku, _kk_source_product: design.productId || design.productHandle || '' });
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }) });
        const payload = await response.json(); if (!response.ok) throw new Error(payload?.description || payload?.message || 'Cart add failed');
        await refreshConfiguredCart(); setStatus(selection.type === 'custom' ? text('textAddedCustom') : text('textAddedStandard'));
      } catch (error) { setStatus(text('textAddError')); root.dataset.kkWafCartError = error?.message || 'unknown'; }
      finally { cartBusy = false; root.setAttribute('aria-busy', 'false'); updateCartButton(updatePrice().variant); }
    };

    modeButtons.forEach((button) => button.addEventListener('click', () => setMode(button.dataset.kkWafMode)));
    cards.forEach((card) => card.addEventListener('click', () => {
      const d = cardDimensions(card); if (!d) return;
      setStatus(''); commitSize(d);
    }));
    [width, depth].forEach((input) => input.addEventListener('input', () => { updateGraphic(); }));
    customApply?.addEventListener('click', () => {
      const w = Number(width.value), d = Number(depth.value);
      if (!validDimensions(w, d, width, depth)) { setStatus(text('textInvalidSelection')); return; }
      commitSize({ width: w, depth: d }, { mode: 'custom' });
    });
    fabricTypes.forEach((button) => button.addEventListener('click', () => { if (selection) setFabricType(button); }));
    fabricTypes.forEach((button) => button.addEventListener('keydown', (event) => {
      if (!ARROW_KEYS.includes(event.key)) return; event.preventDefault(); const index = fabricTypes.indexOf(button); const delta = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1; const next = fabricTypes[(index + delta + fabricTypes.length) % fabricTypes.length]; if (next) { setFabricType(next, false); next.focus(); }
    }));
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => applyDesign(swatch));
      swatch.addEventListener('keydown', (event) => {
        if (!ARROW_KEYS.includes(event.key)) return; event.preventDefault();
        const visible = swatches.filter((item) => item.closest('[data-kk-waf-fabric-group]')?.hidden === false && !item.hidden);
        const index = visible.indexOf(swatch); const delta = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1; const next = visible[(index + delta + visible.length) % visible.length]; if (next) { applyDesign(next, { advance: false }); next.focus(); }
      });
    });
    toggles.forEach((button) => button.addEventListener('click', () => { setOpenStep(button.dataset.kkWafStepToggle, { scroll: true }); updatePrice(); }));
    addToCart?.addEventListener('click', addConfiguredItem);

    const parseQuerySize = () => {
      const params = new URLSearchParams(window.location.search);
      const miniW = params.get('kk_mini_width'), miniD = params.get('kk_mini_depth');
      if (miniW !== null || miniD !== null) {
        if (!/^\d+$/.test(miniW || '') || !/^\d+$/.test(miniD || '')) return null;
        const w = Number(miniW), d = Number(miniD); return validDimensions(w, d, width, depth) ? { width: w, depth: d } : null;
      }
      const values = [params.get('kk_size'), params.get('filter.v.option.größe'), params.get('filter.v.option.size')].filter(Boolean);
      for (const value of values) {
        const match = String(value).match(/^\s*(\d{2,3})\s*(?:x|×|\*)\s*(\d{2,3})(?:\s*cm(?:\s*\([^)]*\))?)?\s*$/i);
        if (match) { const w = Number(match[1]), d = Number(match[2]); if (validDimensions(w, d, width, depth)) return { width: w, depth: d }; }
      }
      return null;
    };
    const initialWidth = cards.find((card) => card.dataset.cardId === '75') ? cardDimensions(cards.find((card) => card.dataset.cardId === '75')) : { width: 75, depth: 70 };
    width.value = String(initialWidth.width); depth.value = String(initialWidth.depth); updateGraphic(); setMode('custom'); clearDesign('');
    fabricGroups.forEach((group) => { group.hidden = true; });
    fabricTypes.forEach((item, index) => { item.classList.remove('is-selected'); item.setAttribute('aria-selected', 'false'); item.tabIndex = index === 0 ? 0 : -1; });
    cards.forEach((card) => { card.classList.remove('is-selected'); card.setAttribute('aria-pressed', 'false'); });
    if (customCard) customCard.dataset.selected = 'false';
    setOpenStep('size');
    const hasSizeQuery = ['kk_mini_width','kk_mini_depth','kk_size','filter.v.option.größe','filter.v.option.size'].some((key) => new URLSearchParams(window.location.search).has(key));
    const incoming = parseQuerySize();
    if (incoming) {
      commitSize(incoming, { incoming: true });
      const params = new URLSearchParams(window.location.search);
      const returnGids = params.getAll('filter.p.m.custom.used_fabrics_filter');
      const gidNumber = (value) => String(value || '').split('/').pop();
      const matchingSwatch = returnGids.map((gid) => swatches.find((item) => gidNumber(item.dataset.designGid) === gidNumber(gid))).find(Boolean);
      if (matchingSwatch) {
        const group = matchingSwatch.closest('[data-kk-waf-fabric-group]');
        const type = fabricTypes.find((item) => item.dataset.fabricKey === group?.dataset.fabricKey);
        if (type) {
          setFabricType(type, false);
          const returnDesign = params.get('kk_return_design');
          const selected = returnDesign && returnGids.some((gid) => gidNumber(gid) === gidNumber(returnDesign)) ? [...group.querySelectorAll('[data-kk-waf-swatch]')].find((item) => gidNumber(item.dataset.designGid) === gidNumber(returnDesign) && !item.hidden) : null;
          if (selected) {
            applyDesign(selected, { advance: false });
            setOpenStep('summary');
          } else {
            setOpenStep('design');
          }
        }
      }
      syncCollectionLink();
    }
    else {
      selection = null; root.dataset.kkWafSelectionType = 'draft'; root.dataset.kkWafSelectionLabel = '';
      root.querySelectorAll('[data-kk-waf-step-toggle="fabric"],[data-kk-waf-step-toggle="design"],[data-kk-waf-step-toggle="summary"]').forEach((button) => { button.disabled = true; });
      updatePrice();
      if (hasSizeQuery) setStatus(text('textInvalidIncomingSize'));
    }
  });
})();
